import "App.css";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "routes";
import { Provider } from "react-redux";
import store from "store/store";
import AuthLoader from "store/authLoader";
import VisitorLogger from "new_components/VisitorLogger/VisitorLogger";
import TrackVisitLogger from "new_components/TrackVisitLogger/TrackVisitLogger";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AuthLoader />
        <TrackVisitLogger />
        <VisitorLogger />
        <AppRoutes />
      </Router>
    </Provider>
  );
}

export default App;
